import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, Card, CardContent, CardHeader, IconButton, } from '@mui/material';
import { useEffect, useState } from 'react';
import { styled } from '../../../utils';
import { Markdown } from '../../Markdown';
import { CircularProgress } from '../../Progress';
export function ReleaseNotesOverlay({ dataUrl, onProcessData, onClose, }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        if (dataUrl) {
            fetch(dataUrl, { mode: 'no-cors' })
                .then((res) => res.text())
                .then((data) => {
                const processedData = onProcessData ? onProcessData(data) : data;
                setData(processedData.replace(/\r\n/g, '\n'));
            })
                .catch((e) => {
                setData('Could not fetch data!');
                console.warn('Failed to fetch data for overlay', e);
            });
        }
    }, [dataUrl, onProcessData]);
    return (_jsx(Backdrop, { open: true, sx: {
            zIndex: 11,
        }, children: _jsxs(CardStyled, { children: [_jsx(CardHeader, { title: "Release Notes", action: _jsx(IconButton, { "aria-label": "settings", onClick: onClose, size: "large", children: _jsx(CloseIcon, {}) }) }), _jsx(CardContentStyled, { children: data === null ? (_jsx(LoadingStyled, { children: _jsx(CircularProgress, {}) })) : (_jsx(DataContainerStyled, { parseRawHTML: true, openLinksInNewTab: true, children: data })) })] }) }));
}
const CardStyled = styled(Card)({
    position: 'fixed',
    width: '90%',
    height: '95%',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
});
const CardContentStyled = styled(CardContent)({
    padding: 0,
    overflow: 'hidden',
});
const LoadingStyled = styled('div')({
    placeItems: 'center',
    display: 'grid',
    height: '100%',
});
const DataContainerStyled = styled(Markdown)(({ theme }) => ({
    overflow: 'auto',
    margin: theme.spacing(0, 2, 2),
    height: '100%',
}));
